import { IGenericModel } from './common/generic-model.model';

export interface INotif extends IGenericModel {
  companyId: number;
  type: NotifType;
  readDate?: Date;
  reader?: string;
  params: any;
}

export enum NotifType {
  TRADE_MATCH = 'TRADE_MATCH',
  TRADE_PROPOSAL = 'TRADE_PROPOSAL',
  TRADE_ACCEPTED = 'TRADE_ACCEPTED',
  TRADE_REFUSED = 'TRADE_REFUSED',
  TRADE_RECALL = 'TRADE_RECALL',
  TRADE_CANCELED = 'TRADE_CANCELED',
  TRADE_EXPIRED = 'TRADE_EXPIRED',
  TRADE_EXPIRED_BY_COMPANY_TICKET = 'TRADE_EXPIRED_BY_COMPANY_TICKET',
  TRADE_EXPIRED_BY_PARTNER_TICKET = 'TRADE_EXPIRED_BY_PARTNER_TICKET',
  SALE_EXPIRED_BY_COMPANY_TICKET = 'SALE_EXPIRED_BY_COMPANY_TICKET',
  SALE_EXPIRED_BY_PARTNER_TICKET = 'SALE_EXPIRED_BY_PARTNER_TICKET',
  SALE_PROPOSAL = 'SALE_PROPOSAL',
  SALE_ACCEPTED = 'SALE_ACCEPTED',
  SALE_REFUSED = 'SALE_REFUSED',
  SALE_CANCELED = 'SALE_CANCELED',
  SALE_EXPIRED = 'SALE_EXPIRED',
  SALE_RECALL = 'SALE_RECALL',
  TICKET_ALMOST_EXPIRED = 'TICKET_ALMOST_EXPIRED',
  TICKET_EXPIRED = 'TICKET_EXPIRED',
  MESSAGE_RECEIVED = 'MESSAGE_RECEIVED',
  THRESHOLD = 'THRESHOLD',
  LOSS_RATE = 'LOSS_RATE',
  CREATE_STOCK = 'CREATE_STOCK',
  CREATE_PLACE = 'CREATE_PLACE',
  SET_UP_ACCOUNT = 'SET_UP_ACCOUNT',
  INVOICE_CREATED = 'INVOICE_CREATED',
  PARTNERSHIP_STATE = 'PARTNERSHIP_STATE',
  PARTNERSHIP_DELETED = 'PARTNERSHIP_DELETED',
  COLLABORATIVE_OPERATION_CREATED = 'COLLABORATIVE_OPERATION_CREATED',
  COLLABORATIVE_OPERATION_ACCEPTED = 'COLLABORATIVE_OPERATION_ACCEPTED',
  COLLABORATIVE_CONTEST_CREATED = 'COLLABORATIVE_CONTEST_CREATED',
  COLLABORATIVE_CONTEST_ACCEPTED = 'COLLABORATIVE_CONTEST_ACCEPTED',
  COLLABORATIVE_CONTEST_REFUSED = 'COLLABORATIVE_CONTEST_REFUSED',
  TRADE_CONTEST_CREATED = 'TRADE_CONTEST_CREATED',
  TRADE_CONTEST_ACCEPTED = 'TRADE_CONTEST_ACCEPTED',
  TRADE_CONTEST_REFUSED = 'TRADE_CONTEST_REFUSED',
  TRADE_CONTEST_CANCELED = 'TRADE_CONTEST_CANCELED',
  TRADE_FINALIZED = 'TRADE_FINALIZED',
  TRADE_CONFIRMED_CREATED = 'TRADE_CONFIRMED_CREATED',
  TRADE_CONFIRMED_UPDATED = 'TRADE_CONFIRMED_UPDATED',
  SALE_CONFIRMED_CREATED = 'SALE_CONFIRMED_CREATED',
  SALE_CONFIRMED_UPDATED = 'SALE_CONFIRMED_UPDATED',
}
